/**
 * Icon map for the inbox subcategory tabs — shared between the admin list
 * (`notifications/list/tabs.tsx`) and the bell tray
 * (`shared/notifications/NotificationTray.tsx`) so the two strips never
 * drift.
 *
 * Co-located with `constants.ts` rather than a `.tsx` because the value is
 * a typed lookup table — JSX-free.
 */
import { AtSign, Inbox, ListChecks, type LucideIcon } from 'lucide-react';
import { INBOX_TABS, type InboxTab } from './constants';

export const INBOX_TAB_ICONS: Record<InboxTab, LucideIcon> = {
  general: Inbox,
  assignment: ListChecks,
  mention: AtSign,
};

// Re-export for callers that want both in one import.
export { INBOX_TABS };
export type { InboxTab };
